module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "starRatingFieldset",
    class: [("starability-" + _vm.kind), 'rating']
  }, [(_vm.legend) ? _c('legend', [_vm._v(_vm._s(_vm.legend))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return [_c('input', {
      attrs: {
        "type": "radio",
        "id": _vm.uuid(index),
        "name": "rating"
      },
      domProps: {
        "value": item.value,
        "checked": _vm.hasChecked(index)
      },
      on: {
        "click": function($event) {
          _vm.change($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "touchable",
      attrs: {
        "for": _vm.uuid(index),
        "title": item.title || ''
      }
    }, [_vm._v(_vm._s(item.label || ''))])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2c7ffc4d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StarRating.vue
// module id = 119
// module chunks = 1